import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-filter-fieldSet',
  templateUrl: './data-filter-fieldset.component.html',
  styleUrls: ['./data-filter-fieldset.component.scss']
})
export class DataFilterFieldsetComponent implements OnInit {


  @Input()
  fieldsetTitleKey: string;
  @Input()
  largeTitle: boolean;

  constructor() { }

  ngOnInit() {
  }

}
